var browser = require('browser');

var ScrollClockView = Backbone.View.extend({
    tagName: 'div',
    className: 'dateWrapper dateChange',
    tickDelay: 1000,
    radius: 7,
    offset: 1,
    getProps: function () {
        return {
            outerBorder: {
                lineWidth: 1.3,
                color: this.getColor(),
                alpha: 1,
                radius: 0.95
            },
            hub: {
                lineWidth: 1,
                fill: this.getColor(),
                color: this.getColor(),
                alpha: 1,
                radius: 0.1
            },
            hourHand: {
                lineWidth: 2,
                color: this.getColor(),
                alpha: 1,
                startAt: 0,
                endAt: 0.6
            },
            minuteHand: {
                lineWidth: 2,
                color: this.getColor(),
                alpha: 1,
                startAt: 0,
                endAt: 0
            }
        };
    },
    getColor: function () {
        return this.clock.css('color');
    },
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.diameter = (this.radius + this.offset) * 2;
        this.visible = false;
    },
    show: function () {
        if (!this.isVisible()) {
            $(this.el).show();
            this.visible = true;
            return true;
        }
    },
    hide: function () {
        if (this.isVisible()) {
            $(this.el).hide();
            this.visible = false;
            return true;
        }
    },
    isVisible:function () {
        return this.visible;
    },
    render: function (offset) {
        var table = $('<table class="date">');
        this.date = $('<td class="scrollDate">');
        this.clock = $('<canvas class="clock">');
        var clockCell = $('<td class="clockcell">');
        // Make the canvas the requested size. It's always square.
        clockCell.width(this.diameter);
        

        this.ctx = this.clock[0].getContext("2d");
        // scale the canvas down with CSS
        this.clock.css({
            width: this.diameter,
            height: this.diameter
        });

        this.timeago = $('<td class="timeago">');
        var row = $('<tr>')
            .append(this.date)
            .append(clockCell.append(this.clock))
            .append(this.timeago);
        table.append(row);
        $(this.el).append(table);
        
        return this;
    },
    getHeight: function (force) {
        if (force) {
            return $(this.el).height();
        } else if (this.isVisible()) {
            return this.height;
        } else {
            return 0;
        }
    },
    cacheHeight: function () {
        this.height = this.getHeight(true);
    },
    update: function (upperMessage, atBottom) {
        if (!upperMessage || atBottom) {
            delete this.upperMessage;
            this.height = 0;
            this.hide();
            return false;
        }

        if (upperMessage.equals(this.upperMessage)) {
            return true;
        }
        
        this.upperMessage = upperMessage;
        
        this.show();
        if (!this.height) {
            this.cacheHeight();
        }
        // Update clock time
        var date = upperMessage.getDate();
        this.date.text(date.toString("dddd, MMMM dS, yyyy"));
        this.timeago.timeago('dispose');
        this.timeago.attr('title', date.toISOString()).text(date.formatFullDate()).timeago();
        
        // Pixel density fix
        var ratio = browser.getPixelRatio();
        // stretch the canvas HTML element
        this.clock.attr('width', this.diameter * ratio);
        this.clock.attr('height', this.diameter * ratio);
        // stretch the bitmap on canvas 
        this.ctx.scale(ratio, ratio);
        
        this.renderClock(date.getHours(), date.getMinutes(), date.getSeconds());
        $(this.el).attr('title', date.formatFullDate());
        return true;
    },
    
    fullCircleAt: function(x, y, style) {
        this.ctx.save();
        // Style
        this.ctx.globalAlpha = style.alpha;
        this.ctx.lineWidth = style.lineWidth;
        this.ctx.strokeStyle = style.color;
        // Draw
        this.ctx.translate(this.offset, this.offset);
        this.ctx.beginPath();
        this.ctx.arc(x, y, style.radius * this.radius, 0, 2 * Math.PI, false);
        if (style.fill) {
            this.ctx.fillStyle = style.fill;
            this.ctx.fill();
        } else {
            this.ctx.stroke();
        }
        
        this.ctx.restore();
    },
    radialLineAtAngle: function (angleFraction, style) {
        this.ctx.save();
        // Style
        this.ctx.globalAlpha = style.alpha;
        this.ctx.lineWidth = style.lineWidth;
        this.ctx.strokeStyle = style.color;
        // Draw
        this.ctx.translate(this.radius + this.offset, this.radius + this.offset);
        this.ctx.rotate(Math.PI * (2 * angleFraction - 0.5));
        this.ctx.beginPath();
        this.ctx.moveTo(style.startAt * this.radius, 0);
        this.ctx.lineTo(style.endAt * this.radius, 0);
        this.ctx.stroke();
        
        this.ctx.restore();
    },
    renderClock: function (hour, min, sec) {
        // Clear
        this.ctx.clearRect(0, 0, this.diameter, this.diameter);
        // Outer border
        var props = this.getProps();
        this.fullCircleAt(this.radius, this.radius, props.outerBorder);
        // Hub
        this.fullCircleAt(this.radius, this.radius, props.hub);
        // Hours
        this.radialLineAtAngle((hour + min / 60) /12, props.hourHand);
        // Mins
        this.radialLineAtAngle((min + sec / 60) /60, props.minuteHand);
    }
});


module.exports = ScrollClockView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/scrollclockview.js
// module id = ZBd7
// module chunks = 1